/**
 * Validates tha event doesn't come from a specified tags
 *
 * @param {array} tags Array of tags to verify against
 */
import moment from 'moment';
import FileSaver from 'file-saver';

export const eventNotTriggeredFrom = (tags) => (e) => {
  if (!Array.isArray(tags) && typeof tags === 'string') tags = [tags];
  return (
    e &&
    e.target &&
    e.target.tagName &&
    e.target.parentNode &&
    tags.every(
      (tag) =>
        typeof tag === 'string' &&
        tag.toUpperCase() !== e.target.tagName &&
        tag.toUpperCase() !== e.target.parentNode.tagName
    )
  );
};

export const valueFromEvent = (e, extra) => {
  let target, name, value;
  if (e._isAMomentObject) {
    target = e.target;
    name = target.name;
    value = e.toISOString();

    // console.log(target);
    // console.log(name);
    // console.log(value);

    return { [name]: value };
  }
  target = e.target;
  name = target.name;
  value = target.type === 'checkbox' ? target.checked : target.value;

  // console.log(target);
  // console.log(name);
  // console.log(value);

  // if(extra){ // En caso de tener un path mas largo se puede diseñar desde el handler.
  //   // return { [extra.path]: [{ value, key:"celular011d" } ] };
  //   return { value, [name]: name };
  // }
  return { [name]: value };
};

const generatePath = (path) => {
  return {};
};

const generatePathArray = (path, index) => {
  let jsonArray = [];
  jsonArray[index] = {};
  return jsonArray;
};

export const createRoute = (companyId, subcompanyId, path) =>
  `/companies/${companyId}/subcompanies/${subcompanyId}/${path}`;

export const colors = (function* () {
  const colors = ['#8776a9', '#ffb848', '#32c5d3', '#f3565c', '#f1c40e', '#3597dc', '#1cbc9a'];
  let i = 0;

  while (true) {
    yield colors[i];
    i++;
    i = i < colors.length ? i : 0;
  }
})();

export const formatNumber = (value) =>
  value && parseFloat(value) ? parseFloat(value).toFixed(2) : `0.00`;

export const formatCurrency = (value) => `$ ${formatNumber(value)}`;

export const formatDate = (value) => {
  value = moment(value);
  return value.isValid() ? value.format('DD/MM/YYYY') : '';
};

export const formatTimeStamp = (value) => {
  value = moment(value);
  return value.isValid() ? value.format('DD/MM/YYYY HH:mm:ss') : '';
};

export const saveAsCSV = (name, endDate, data) => {
  const blob = new Blob([data], { type: 'text/csv;charset=utf-8' });
  FileSaver.saveAs(
    blob,
    `${name}-${moment(endDate).format('DDMMYYYY')}-${moment().format('DDMMYYYY')}.csv`
  );
};



// WEBPACK FOOTER //
// src/lib/util.js